module.exports = __webpack_public_path__ + "img/1.4c2ce360.png";